import { Button, Field, Input, useI18n } from '@upweo/ui';
import { type FormEvent, useState } from 'react';

import { ApiClientError } from '../lib/api-client.js';
import { usePartner } from '../lib/partner-context.js';

export const LoginPage = (): React.JSX.Element => {
  const { t } = useI18n();
  const { signIn } = usePartner();
  const [email, setEmail] = useState('dev@partner.test');
  const [password, setPassword] = useState('Password123!');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const onSubmit = (event: FormEvent<HTMLFormElement>): void => {
    event.preventDefault();
    setError(null);
    setBusy(true);
    void (async () => {
      try {
        await signIn(email, password);
      } catch (err) {
        setError(
          err instanceof ApiClientError ? err.error.message : 'Something went wrong. Try again.',
        );
      } finally {
        setBusy(false);
      }
    })();
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-muted/30 p-6">
      <div className="w-full max-w-sm rounded-xl border bg-card p-8 shadow-sm">
        <h1 className="text-2xl font-semibold tracking-tight">Upweo Partners</h1>
        <p className="mt-1 text-sm text-muted-foreground">{t('auth.partnerSubtitle')}</p>

        <form onSubmit={onSubmit} className="mt-6 space-y-4">
          <Field label={t('common.email')} htmlFor="email">
            <Input
              id="email"
              type="email"
              autoComplete="username"
              required
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
              }}
            />
          </Field>

          <Field label={t('common.password')} htmlFor="password">
            <Input
              id="password"
              type="password"
              autoComplete="current-password"
              required
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
              }}
            />
          </Field>

          {error && (
            <p
              role="alert"
              className="rounded-md bg-destructive/10 px-3 py-2 text-sm text-destructive"
            >
              {error}
            </p>
          )}

          <Button type="submit" disabled={busy} className="w-full">
            {busy ? 'Signing in…' : 'Sign in'}
          </Button>
        </form>

        <p className="mt-6 border-t pt-4 text-xs text-muted-foreground">
          A merchant account cannot sign in here — the API issues partner tokens with a different
          audience, and only accounts with a PartnerAccount are admitted.
        </p>
      </div>
    </div>
  );
};
